/* eslint-disable */

import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from "@/js/auth"

//Apps
import App from "../views/App.vue"
import ApplicantApp from "../views/Applicants/App.vue"
import AdminApp from "../views/Admin/App.vue"

//Applicant
import ApplicantHome from "../views/Applicants/Home/Home.vue"
import Profile from "../views/Applicants/Items/Profile.vue"
import MyApplications from "../views/Applicants/Items/MyApplications.vue"
import BrowsePostings from "../views/Applicants/Items/BrowsePostings.vue"

//Applicant-Login
import Register from "../views/Applicants/Authentication/Register.vue"
import Login from "../views/Applicants/Authentication/Login.vue"
import ForgetPW from "../views/Applicants/Authentication/ForgotPassword.vue"
import ReVerify from "../views/Applicants/Authentication/ReVerifyEmail.vue"

//Admin
import AdminHome from "../views/Admin/Home/Home.vue"
import ApplicationManager from "../views/Admin/Items/Applications.vue"
import AccountManager from "../views/Admin/Items/AccountManager.vue"
import PostingsBrowser from "../views/Admin/Items/PostingsBrowser.vue"
import PostingsManager from "../views/Admin/Items/PostingsManager.vue"
import DepartmentManager from "../views/Admin/Items/DepartmentManager.vue"
import Permissions from "../views/Admin/Items/Permissions.vue"
import Export from "../views/Admin/Items/Export.vue"
import Report from "../views/Admin/Items/Report.vue"
import ITSPage from "../views/Admin/Items/ITSPage.vue"
//Admin-Settings
import Announcement from "../views/Admin/Items/Announcement.vue"
import Timetable from "../views/Admin/Items/TimetableControl.vue"
import FormControl from "../views/Admin/Items/FormControl.vue"
//import PostingControl from "../views/Admin/Items/PostingControl.vue"
import EmailContent from "../views/Admin/Items/EditEmailContent.vue"
//import CUPERepresentative from "../views/Admin/Items/CUPERepresentative.vue"

//Access
import Unauthorized from "../views/Access/Unauthorized.vue"
import SystemMaintenance from "../views/Access/SystemMaintenance.vue"

//Open Job postings
import JobPostings from "../views/OpenJobPostingView.vue"


Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes : [
    {
      path: "/",
      name: "App",
      alias: "/",
      component: App,
      children: [
        {
          path: "/",
          name: "ApplicantApp",
          alias: "/",
          component: ApplicantApp,
          redirect: {name: "applicanthome"},
          children: [
            {
              path: "/home",
              alias: "/home",
              component: ApplicantHome,
              name: "applicanthome",
              beforeEnter: checkApplicant
            },
            {
              path: "/profile",
              alias: "/profile",
              component: Profile,
              beforeEnter: checkApplicant
            },
            {
              path: "/myapplications",
              alias: "/myapplications",
              component: MyApplications,
              beforeEnter: checkApplicant
            },
            {
              path: "/browsepostings",
              alias: "/browsepostings",
              component: BrowsePostings,
              beforeEnter: checkApplicant
            },
          ],
          beforeEnter: checkApplicant
        },
        {
          path: "/admin",
          name: "AdminApp",
          alias: "/admin",
          redirect: {name: "AdminHome"},
          component: AdminApp,
          children: [
            {
              path: "/admin/home",
              name: "AdminHome",
              component: AdminHome,
              beforeEnter: checkAdmin
            },
            {
              path: "/admin/applications",
              alias: "/applications",
              component: ApplicationManager,
              beforeEnter: applicationPermission
            },
            {
              path: "/admin/postingsbrowser",
              alias: "/postingsbrowser",
              component: PostingsBrowser,
              beforeEnter: checkAdmin
            },
            {
              path: "/admin/managepostings",
              alias: "/managepostings",
              component: PostingsManager,
              beforeEnter: checkAdmin
            },
            {
              path: "/admin/manageaccounts",
              alias: "/manageaccounts",
              component: AccountManager,
              beforeEnter: accountManagerPermission
            },
            {
              path: "/admin/managedepartment",
              alias: "/managedepartment",
              component: DepartmentManager,
              beforeEnter: academicDepartmentPermission
            },
            {
              path: "/admin/setpermissions",
              alias: "/setpermissions",
              component: Permissions,
              beforeEnter: permissionsPermission
            },
            {
              path: "/admin/export",
              alias: "/export",
              component: Export,
              beforeEnter: exportPermission
            },
            {
              path: "/admin/report",
              alias: "/report",
              component: Report,
              beforeEnter: reportPermission
            },
            {
              path: "/admin/announcement",
              alias: "/announcement",
              component: Announcement,
              beforeEnter: announcementPermission
            },
            {
              path: "/admin/timetablemanagement",
              alias: "/timetablemanagement",
              component: Timetable,
              beforeEnter: timetablePermission
            },
            {
              path: "/admin/formcontrol",
              alias: "/formcontrol",
              component: FormControl,
              beforeEnter: formControlPermission
            },
            {
              path: "/admin/editemailcontent",
              alias: "/editemailcontent",
              component: EmailContent,
              beforeEnter: emailReceiptPermission
            },
            {
              path: "/admin/itsonly",
              alias: "/itsonly",
              component: ITSPage,
              beforeEnter: checkITS
            }
          ],
          beforeEnter: checkAdmin
        }
      ],
      beforeEnter: requireAuth
    },
    {
      path: "/signin",
      name: "Login",
      alias: "/signin",
      component: Login,
      beforeEnter: checkAuthentication
    },
    {
      path: "/register",
      name: "RegisterApplicant",
      alias: "/register",
      component: Register,
      beforeEnter: checkMaintenanceStatus
    },
    {
      path: "/forgetpassword",
      alias: "/forgetpassword",
      component: ForgetPW,
      beforeEnter: redirectFPW
    },
    {
      path: "/reverifyemail",
      alias: "/reverifyemail",
      component: ReVerify,
      beforeEnter: redirectFPW
    },
    {
      path: "/unauthorized",
      alias: "/unauthorized",
      component: Unauthorized,
      beforeEnter: checkAuthorization
    },
    {
      path: "/undermaintenance",
      alias: "/undermaintenance",
      component: SystemMaintenance,
      beforeEnter: checkMaintenance
    },
    {
      path: "/jobpostings",
      alias: "/jobpostings",
      name: "JobPostings",
      component: JobPostings,
      beforeEnter: checkSession
    },
    {
      path: '/jobpostings/:postingid',
      component: JobPostings,
      props: true,
    }
  ]
})

/*
{
  path: "/postingcontrol",
  alias: "/postingcontrol",
  component: PostingControl,
  beforeEnter: formControlPermission
},
{
  path: "/setcuperep",
  alias: "/setcuperep",
  component: CUPERepresentative,
  beforeEnter: formControlPermission
},

*/
function redirect(to, from, next) {
  // Redirect all paths to unauthenticated check
  next({
      path: '/signin'
  });
}

function redirectFPW(to, from, next) {
  if(from.path === '/signin' && to.path !== '/signin'){
    next();
  }else {
    next({
      path: '/signin'
    })
  }
}

function redirectTo(next) {
  // Redirect based on session type
  if (auth.is_applicant()) {
    if(auth.is_account_active()){
      next({
        path: '/'
      });
    }else {
      next({
        path: '/unauthorized'
      });
    }
  }else if(auth.is_AdminMember()){
      next({
          path: "/admin"
      });
  }else{
      next({
          path: '/unauthorized'
      });
  }
}

function requireAuth(to, from, next) {
  // Check if user is authenticated
  auth.authenticate().then(function (response) {
    if (response) {
      if(auth.get_maintenance() == "none"){
        // Navigate to specified view if authenticated
        next();
      }else if(auth.get_maintenance() == "applicant"){
        if(auth.is_applicant()){
          next({
            path: '/undermaintenance'
          });
        }else {
          next();
        }
      }else if(auth.get_maintenance() == "all"){
        if(auth.is_ITS()){
          next();
        }else {
          next({
            path: '/undermaintenance'
          });
        }
      }
    } else {
        // Redirect to unauthenticated view
        next({
            path: '/signin'
        })
    }
  }).catch(function () {
      // Redirect to unauthenticated view
      next({
        path: '/signin'
      })
  })
  
}

function checkAuthentication(to, from, next) {
  // Check user authentication
  auth.authenticate().then(function (response) {
      if (response) {
        if(auth.get_maintenance() == "none"){
          // Redirect to proper route
          redirectTo(next);
        }else if(auth.get_maintenance() == "applicant"){
          if(auth.is_applicant()){
            next({
              path: '/undermaintenance'
            });
          }else {
            // Redirect to proper route
            redirectTo(next);
          }
        }else if(auth.get_maintenance() == "all"){
          if(auth.is_ITS()){
            // Redirect to proper route
            redirectTo(next);
          }else {
            next({
              path: '/undermaintenance'
            });
          }
        }
      } else {
        if(auth.get_maintenance() == "none"){
          next();
        }else if(auth.get_maintenance() == "applicant"){
          if(auth.is_applicant()){
            next({
              path: '/undermaintenance'
            });
          }else {
            // Redirect to proper route
            next();
          }
        }else if(auth.get_maintenance() == "all"){
          if(auth.is_ITS()){
            next();
          }else {
            next({
              path: '/undermaintenance'
            });
          }
        }
      }
  })
  .catch(function () {
      // Redirect to unauthenticated view
      next();
  })
}

function checkAuthorization(to, from, next) {
  if (auth.is_applicant()) {
    if(auth.is_account_active()){
      next({
        path: '/'
      });
    }else {
      next();
    }
  } else if(auth.is_AdminMember()){
    next({
      path: '/admin'
    });
  }else {
    next();
  }
}

function checkApplicant(to, from, next){
  // Check if the user is not an admin
  if (auth.is_applicant()) {
    if(auth.is_account_active()){
      if(auth.get_maintenance() == "none"){
        next();
      }else {
        next({
          path: '/undermaintenance'
        });
      }
    }else {
      next({
        path: '/unauthorized'
      });
    }
  } else {
      next({
        path: '/unauthorized'
      })
  }
}

function checkAdmin(to, from, next){
  //Check if the user is admin
  if(auth.is_AdminMember()){
    if(auth.get_maintenance() == "none" || auth.get_maintenance() == "applicant"){
      next();
    }else {
      if(auth.is_ITS()){
        next();
      }else {
        next({
          path: '/undermaintenance'
        });
      }
    }
  }else {
    next({
      path: '/unauthorized'
    });
  }
}

function checkITS(to, from, next){
  if(auth.is_AdminMember()){
    if(auth.is_ITS()){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }else {
    next({
      path: '/'
    });
  }
}

function checkMaintenance(to, from, next){
  if(auth.get_maintenance() == "none"){
    next({
      path: '/signin'
    });
  }else {
    next();
  }
}

function checkMaintenanceStatus(to, from, next){
  if(auth.get_maintenance() == "none"){
    next();
  }else {
    next({
      path: '/undermaintenance'
    });
  }
}


//Added 2023 06 06 to include browse postings page that does not require authentication
function checkSession(to, from, next){
  // Check if the user is not an admin
  if (auth.is_applicant()) {
    if(auth.is_account_active()){
      next({
        path: '/browsepostings'
      });
    }else {
      next();
    }
  } else {
    next();
  }
}

/*-----------------------------Permission Settings----------------------------------------*/


function applicationPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("allowedDepartments")){
    if(auth.get_permissions()["allowedDepartments"].length == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}


function permissionsPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("adminpermissionsmanage")){
    if(auth.get_permissions()["adminpermissionsmanage"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function academicDepartmentPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("getacademicdepartments")){
    if(auth.get_permissions()["getacademicdepartments"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function accountManagerPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("getaccountslist")){
    if(auth.get_permissions()["getaccountslist"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function exportPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("exportdata")){
    if(auth.get_permissions()["exportdata"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function reportPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("allowedDepartments")){
    if(auth.get_permissions()["allowedDepartments"].length == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function announcementPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("setannouncement")){
    if(auth.get_permissions()["setannouncement"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function timetablePermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("timetableinterface")){
    if(auth.get_permissions()["timetableinterface"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function formControlPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("adminformcontrol")){
    if(auth.get_permissions()["adminformcontrol"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}

function emailReceiptPermission(to, from, next){
  if(auth.get_permissions().hasOwnProperty("setemail")){
    if(auth.get_permissions()["setemail"] == 0){
      next({
        path: '/admin'
      });
    }else {
      next();
    }
  }else {
    if(auth.get_permissions().hasOwnProperty("rootgroup")){
      next();
    }else {
      next({
        path: '/admin'
      });
    }
  }
}




export default router